import store from '@/store';
import { hasAdminAccess, hasRole } from '@/shared/auth/rbac';
import { ROLES } from '@/shared/constants/roles';

function getStudentSupportAccessContext() {
  return {
    aiAdmin: store.state.auth?.aiAdmin === true,
    userRole: store.state.auth?.userRole || store.state.userRole || '',
    roleCatalog: store.state.auth?.roleCatalog || null,
  };
}

function canAccessStudentSupport() {
  const { aiAdmin, userRole, roleCatalog } = getStudentSupportAccessContext();
  if (!roleCatalog) return false;

  return (
    hasRole(userRole, roleCatalog, ROLES.STUDENT) ||
    hasAdminAccess(aiAdmin, userRole, roleCatalog)
  );
}

function guardStudentSupportRoute(to, from, next) {
  if (!canAccessStudentSupport()) {
    next({ name: 'not-found' });
    return;
  }

  next();
}

export const studentSupportRoutes = [
  {
    path: 'student-support',
    name: 'student-support',
    component: () => import('./views/StudentSupportRouteView.vue'),
    beforeEnter: guardStudentSupportRoute,
  },
];
